import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  featureList: { loading: false, data: null, error: null },
};

export const FeatureSlice = createSlice({
  name: "feature",
  initialState,
  reducers: {
    fetchFeatureListRequest: (feature, action) => {
      feature.featureList.loading = true;
      feature.featureList.error = null;
    },
    fetchFeatureListSuccess: (feature, action) => {
      feature.featureList.data = action.payload;
      feature.featureList.loading = false;
      feature.featureList.error = null;
    },
    fetchFeatureListFailure: (feature, action) => {
      feature.featureList.data = null;
      feature.featureList.loading = false;
      feature.featureList.error = action.payload;
    },
  },
});

export const {
  fetchFeatureListRequest,
  fetchFeatureListSuccess,
  fetchFeatureListFailure,
} = FeatureSlice.actions;

export const getFeatureListState = (store) =>
  store.featureSlice.featureList.data;
export default FeatureSlice.reducer;
